export default __webpack_public_path__ + "static/media/offroadexterior0000.7cd2166f.jpg";